import { createModalContext, useModalState } from '@/common/app/modal'
import { ArticleProposalDetail, ArticleTone } from '@/common/model/media/article'
import { ChildProps } from '@/common/util/props'

import ArticleRewriteModal from '@/components/container/modal/article/ArticleRewriteModal'
import { AppliedArticleRewriteFields } from '@/components/container/modal/article/articleRewriteApply'

interface ArticleRewriteModalState {
  siteId: number
  detail: ArticleProposalDetail | null
  // 記事編集フォームの現在のトーン・ペルソナ（未保存の変更を含む）。未指定なら保存済みの値が使われる
  tone?: ArticleTone
  persona?: string
  onApply?: (fields: AppliedArticleRewriteFields) => void
}

const defaultValue: ArticleRewriteModalState = { siteId: 0, detail: null }

export const ArticleRewriteModalContext = createModalContext<ArticleRewriteModalState>(defaultValue)

const ArticleRewriteModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ArticleRewriteModalState>(defaultValue)
  return (
    <ArticleRewriteModalContext.Provider value={state}>
      {children}
      <ArticleRewriteModal />
    </ArticleRewriteModalContext.Provider>
  )
}

export default ArticleRewriteModalProvider
